/* eslint-disable react/react-in-jsx-scope */
import { useNavigate } from 'react-router-dom';

import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { SxProps } from '@mui/system/styleFunctionSx/styleFunctionSx';

import Apps from '@mui/icons-material/Apps';

const appBarProps: SxProps = {
  zIndex: 2,
  height: "44px",
  p: 0,
  background: "#24125F"
};

const appIconButtonProps: SxProps = {
  borderRadius: 0,
  m: 0,
  ml: "0px",
  pl: "4px",
  height: "42px",
  maxHeight: "42px"
};

const appIconImageProps: SxProps = {
  borderRadius: 0,
  ml: "4px",
  mr: "12px", width: "32px", height: "30px"
};

const appTitleProps: SxProps = {
  ml: 0,
  pt: "0px",
  fontSize: "20px"
};

const Banner = () => {
  const navigate = useNavigate();

  return (
    <AppBar position="relative" sx={appBarProps} data-testid="app-banner">
      <Box sx={{ display: 'flex' }}>
        <IconButton
          onClick={() => { navigate("/") }}
          edge="start"
          color="inherit"
          aria-label="menu"
          sx={appIconButtonProps}
          data-testid="banner-home-button"
        >
          <Apps sx={appIconImageProps} data-testid="banner-home-icon" />
          <Typography variant="h5" flexGrow={0} sx={appTitleProps}></Typography>
        </IconButton>
        {/* <Login /> */}
      </Box>
    </AppBar>
  )
}

export default Banner;